export enum FlowStatus {
  STOPPED = "stopped",
  STARTED = "started",
  SUCCESS = "success",
  FAILURE = "failure",
}
